/**
 * Тип пользователя (физическое или юридическое лицо)
 */
export enum UserViewType {
	Fiz = 'fiz',
	Yur = 'yur'
}

/**
 * Опция для переключения типа пользователя
 */
export interface UserViewTypeOption {
	label: string
	value: UserViewType
}

/**
 * Стандартные опции для переключения между физ/юр лицом
 */
export const USER_VIEW_TYPE_OPTIONS: UserViewTypeOption[] = [
	{
		label: 'Физическое лицо',
		value: UserViewType.Fiz
	},
	{
		label: 'Юридическое лицо',
		value: UserViewType.Yur
	}
]
